import request from 'components/Utils/Request';
const { REACT_APP_API_URL } = process.env;
export const ADD_SCHEDULERS_DETAILS_REQUEST = 'ADD_SCHEDULERS_DETAILS_REQUEST';
export const ADD_SCHEDULERS_DETAILS_SUCCESS = 'ADD_SCHEDULERS_DETAILS_SUCCESS';
export const ADD_SCHEDULERS_DETAILS_FAILURE = 'ADD_SCHEDULERS_DETAILS_FAILURE';
export const SCHEDULERS_LIST_REQUEST = 'SCHEDULERS_LIST_REQUEST';
export const SCHEDULERS_LIST_SUCCESS = 'SCHEDULERS_LIST_SUCCESS';
export const SCHEDULERS_LIST_FAILURE = 'SCHEDULERS_LIST_FAILURE';
export const UPDATE_SCHEDULERS_REQUEST = 'UPDATE_SCHEDULERS_REQUEST';
export const UPDATE_SCHEDULERS_SUCCESS = 'UPDATE_SCHEDULERS_SUCCESS';
export const UPDATE_SCHEDULERS_FAILURE = 'UPDATE_SCHEDULERS_FAILURE';
export const VIEW_EMAIL_SETTING_DETAIL_REQUEST = 'VIEW_EMAIL_SETTING_DETAIL_REQUEST';
export const VIEW_EMAIL_SETTING_DETAIL_SUCCESS = 'VIEW_EMAIL_SETTING_DETAIL_SUCCESS';
export const VIEW_EMAIL_SETTING_DETAIL_FAILURE = 'VIEW_EMAIL_SETTING_DETAIL_FAILURE';
export const UPDATE_EMAIL_SETTING_DETAIL_REQUEST = 'UPDATE_EMAIL_SETTING_DETAIL_REQUEST';
export const UPDATE_EMAIL_SETTING_DETAIL_SUCCESS = 'UPDATE_EMAIL_SETTING_DETAIL_SUCCESS';
export const UPDATE_EMAIL_SETTING_DETAIL_FAILURE = 'UPDATE_EMAIL_SETTING_DETAIL_FAILURE';

export const schedulersDetailsRequest = () => ({
    type: ADD_SCHEDULERS_DETAILS_REQUEST
  });
  export const schedulersDetailsSuccess = payload => ({
    type: ADD_SCHEDULERS_DETAILS_SUCCESS,
    payload
  });
  export const schedulersDetailsFailure = payload => ({
    type: ADD_SCHEDULERS_DETAILS_FAILURE,
    payload
  });

  export const schedulersListRequest = () => ({
    type: SCHEDULERS_LIST_REQUEST
  });
  export const schedulersListSuccess = payload => ({
    type: SCHEDULERS_LIST_SUCCESS,
    payload
  });
  export const schedulersListFailure = payload => ({
    type: SCHEDULERS_LIST_FAILURE,
    payload
  });

    export const updateSchedulersDetailRequest = () => ({
      type: UPDATE_SCHEDULERS_REQUEST
    });
    export const updateSchedulersDetailSuccess = payload => ({
      type: UPDATE_SCHEDULERS_SUCCESS,
      payload
    });
    export const updateSchedulersDetailFailure = payload => ({
      type: UPDATE_SCHEDULERS_FAILURE,
      payload
    });

  export const viewEmailSettingDetailRequest = () => ({
    type: VIEW_EMAIL_SETTING_DETAIL_REQUEST
  });
  export const viewEmailSettingDetailSuccess = payload => ({
    type: VIEW_EMAIL_SETTING_DETAIL_SUCCESS,
    payload
  });
  export const viewEmailSettingDetailFailure = payload => ({
    type: VIEW_EMAIL_SETTING_DETAIL_FAILURE,
    payload
  });
  

    export const updateEmailSettingDetailRequest = () => ({
    type: UPDATE_EMAIL_SETTING_DETAIL_REQUEST
  });
  export const updateEmailSettingDetailSuccess = payload => ({
    type: UPDATE_EMAIL_SETTING_DETAIL_SUCCESS,
    payload
  });
  export const updateEmailSettingDetailFailure = payload => ({
    type: UPDATE_EMAIL_SETTING_DETAIL_FAILURE,
    payload
  });

  export const schedulersDataDetailAction = payload => {
    return {
      type: 'SCHEDULERDETAILSDATA',
      payload
    };
  };
  
  export const schedulersErrorAction = payload => {
    return {
      type: 'SCHEDULERSDETAILSERROR',
      payload
    };
  };

    export const emailSettingDataDetailAction = payload => {
    return {
      type: 'EMAILSETTINGSDETAILSDATA',
      payload
    };
  };
  
  export const emailSettingsErrorAction = payload => {
    return {
      type: 'EMAILSETTINGSDETAILSERROR',
      payload
    };
  };
  
  export const addSchedulersAPI = (payload, successData, errorMSg, headers = {}) => {
    return dispatch => {
      dispatch(schedulersDetailsRequest());
      return request(
        'POST',
        `${REACT_APP_API_URL + '/add-scheduler-detail'}`,
        payload,
        "",
        headers
      )
        .then(res => {
          if (res?.data.status === 200) {
            successData(res);
            dispatch(schedulersDetailsSuccess(res));
          } else {
            errorMSg(res);
          }
        })
        .catch(err => {
          errorMSg(err?.res);
          dispatch(schedulersDetailsFailure('Something went wrong'));
          throw err;
        });
    }
  }

  export const schedulersListAPI = (payload, successData, errorMSg, headers = {}) => {
  return dispatch => {
    dispatch(schedulersListRequest());
    return request(
      'POST',
      `${REACT_APP_API_URL + '/scheduler-list'}`,
      payload,
      "",
      headers
    )
      .then(res => {
        if (res?.data.status === 200) {
          successData(res);
          dispatch(schedulersListSuccess(res));
        } else {
          errorMSg(res);
        }
      })
      .catch(err => {
        errorMSg(err?.res);
        dispatch(schedulersListFailure('Something went wrong'));
        throw err;
      });
  };
};

  export const updateSchedulersDetailAPI = (payload, successData, errorMSg, headers = {}) => {
    return dispatch => {
      dispatch(updateSchedulersDetailRequest());
      return request(
        'POST',
        `${REACT_APP_API_URL + '/update-scheduler-detail'}`,
        payload,
        "",
        headers
      )
        .then(res => {
          if (res?.data.status === 200) {
            successData(res);
            dispatch(updateSchedulersDetailSuccess(res));
          } else {
            errorMSg(res);
          }
        })
        .catch(err => {
          errorMSg(err?.res);
          dispatch(updateSchedulersDetailFailure('Something went wrong'));
          throw err;
        });
    };
  };

    export const updateEmailSettingDetailAPI = (payload, successData, errorMSg, headers = {}) => {
    return dispatch => {
      dispatch(updateEmailSettingDetailRequest());
      return request(
        'POST',
        `${REACT_APP_API_URL + '/update-email-settings'}`,
        payload,
        "",
        headers
      )
        .then(res => {
          if (res?.data.status === 200) {
            successData(res);
            dispatch(updateEmailSettingDetailSuccess(res));
          } else {
            errorMSg(res);
          }
        })
        .catch(err => {
          errorMSg(err?.res);
          dispatch(updateEmailSettingDetailFailure('Something went wrong'));
          throw err;
        });
    };
  };

    export const viewEmailSettingDetailAPI = (payload, successData, errorMSg, headers = {}) => {
    return dispatch => {
      dispatch(viewEmailSettingDetailRequest());
      return request(
        'POST',
        `${REACT_APP_API_URL + '/view-email-setting-detail'}`,
        payload,
        "",
        headers
      )
        .then(res => {
          if (res?.data.status === 200) {
            successData(res);
            dispatch(viewEmailSettingDetailSuccess(res));
          } else {
            errorMSg(res);
          }
        })
        .catch(err => {
          errorMSg(err?.res);
          dispatch(viewEmailSettingDetailFailure('Something went wrong'));
          throw err;
        });
    };
  };